import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Input, Select, Textarea } from '../../../components/base/index';

export default function BuatKlasifikasiForm(props) {


  const { onFormChange, form } = props;
  return (
    <div className="nilai-kognitif__custom-form">
      <div className="nilai-kognitif__custom-form-row">
        <div className="nilai-kognitif__custom-form-row__field">
          <Input
            name="namaSaudara1"
            label="Kode"
            onChange={onFormChange}
            data={ '7A', 'kelas7a'}
            placeholder={'Kelas 7A'}
           
            // error={form.error.namaSaudara1 || ''}
          />
        </div>
        
        <div className="nilai-kognitif__custom-form-column__field">
            
          <Input
           
            name="tahunajaran"
            label="Keterangan"
            onChange={onFormChange}
            value={form.value.tempatLahirSaudara1 || ''}
            error={form.error.tempatLahirSaudara1 || ''}
            placeholder={'2019 - 2020'}
          />
          
       
         
        </div>
        </div>
       
       
        
        </div>
        
 
   
  );
}
BuatKlasifikasiForm.propTypes = {
  onFormChange: PropTypes.func,
  form: PropTypes.object.isRequired,
};
BuatKlasifikasiForm.defaultProps = {
  onFormChange: noop,
};
